export const getInitials = (string, limit) => {
    const length = string?.match(/[A-Z]/g).length;

    return string
        ?.match(/[A-Z]/g)
        ?.slice(0, length < limit ? length : limit)
        ?.join('');
};
